export const getVendorField = (vendorData, field, optionalField, flagDomainData) => {
    if (vendorData) {
        let fieldLower = field?.toLowerCase();
        let fieldData = vendorData?.vendor_field_data?.find((data) => data?.vendor_field_name?.toLowerCase() == fieldLower)
        if (flagDomainData) {
            if (fieldLower == "siteurl") {
                return vendorData['vendor_domain'] ? `https://${vendorData['vendor_domain']}` : optionalField
            }
            return vendorData[fieldLower] || optionalField
        }
        else {
            if (fieldData) {
                return fieldData?.vendor_field_value || optionalField
            }
            return optionalField
        }
    }
    else {
        return optionalField
    }
}